import { gql } from '@/__generated__';

const CREATE_DEVICE_VPN_CERTIFICATE = gql(`
  mutation CreateDeviceConfiguration_CreateDeviceVpnCertificate($deviceId: ID!) {
    createDeviceVpnCertificate(deviceId: $deviceId)
  }
`);

export default CREATE_DEVICE_VPN_CERTIFICATE;
